import styled from 'styled-components';

export const FirstTabContainer = styled.ul`
  overflow-x: auto;
  border-bottom: ${({ theme }) => `1px ${theme.colors.platinum} solid`};
  gap: ${({ theme }) => theme.spacing.s};
  display: flex;
  list-style: none;
  margin-bottom: ${({ theme }) => theme.spacing.m};
`;

export const TabContainer = styled.ul`
  overflow-x: auto;
  gap: ${({ theme }) => theme.spacing.s};
  display: flex;
  list-style: none;
`;
